


























import { Vue, Inject, Prop } from "vue-property-decorator";
import Component from "vue-class-component";
import Constants from "../constants";

@Component({
  props: [
    "id",
    "cols",
    "name",
    "value",
    "label",
    "validate",
    "type",
    "min",
    "max",
    "disabled",
    "labelCols",
    "fileInfo"       
  ]
})
export default class FileInput extends Vue {
  @Inject()
  parentValidator: any;

  @Prop()
  name: any;
  @Prop()
  validate: any;
  @Prop()
  labelCols: any;
  file: File | null = null;
  @Prop()
  fileInfo: any;

  lCols: any = this.labelCols ? this.labelCols : 2;
  protected created() {
    this.$validator = this.parentValidator;
  }

  hasError() {
    return this.$validator.errors.has(this.name);
  }

  errorMessage() {
    return this.$validator.errors.first(this.name);
  }

  hasValidation() {
    return this.validate && this.validate.includes("required");
  }

  errorState(name: any) {
    return this.$validator.errors.has(name) ? false : null;
  }

  importFileHandler(e: any) {
    this.file = (e.target as any).files[0];
    this.$emit("input", { file: this.file, fileInfo: null });
  }

  downloadUrl(id: any) {
    return Constants.baseUrl + "/file/" + id;
  }

  get getFileName() {    
    if (!this.file) {
      if (!this.fileInfo || !this.fileInfo.name) {
        return this.$t('Выберите файл...');
      } else {
        return this.fileInfo.name;
      }
    }

    return this.file.name;
  }

  get fileId() {
    return this.fileInfo != null ? this.fileInfo.id : null;
  }
}
